import styles from './style.module.css';
import loadingIcon from '../../../assets/images/logo.png';

export default function PageLoading() {
  return (
    <div className="w-100 d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <img className={`${styles.loadingIcon}`} src={loadingIcon} alt="loading-icon" />
    </div>
  )
}